// @ts-nocheck
import * as Types from '../../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type ArchiveItemTemplateVersionsMutationVariables = Types.Exact<{
  templateId: Array<Types.Scalars['ID']['input']> | Types.Scalars['ID']['input'];
  archiveAllVersions?: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
}>;


export type ArchiveItemTemplateVersionsMutation = { __typename?: 'Mutation', archiveItemTemplateVersions: { __typename?: 'EmptyResult', emptyResult?: string | null | undefined } };


export const ArchiveItemTemplateVersionsDocument = gql`
    mutation ArchiveItemTemplateVersions($templateId: [ID!]!, $archiveAllVersions: Boolean) {
  archiveItemTemplateVersions(
    input: {templateId: $templateId, archiveAllVersions: $archiveAllVersions}
  ) {
    emptyResult
  }
}
    `;
export type ArchiveItemTemplateVersionsMutationFn = Apollo.MutationFunction<ArchiveItemTemplateVersionsMutation, ArchiveItemTemplateVersionsMutationVariables>;

/**
 * __useArchiveItemTemplateVersionsMutation__
 *
 * To run a mutation, you first call `useArchiveItemTemplateVersionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArchiveItemTemplateVersionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [archiveItemTemplateVersionsMutation, { data, loading, error }] = useArchiveItemTemplateVersionsMutation({
 *   variables: {
 *      templateId: // value for 'templateId'
 *      archiveAllVersions: // value for 'archiveAllVersions'
 *   },
 * });
 */
export function useArchiveItemTemplateVersionsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ArchiveItemTemplateVersionsMutation, ArchiveItemTemplateVersionsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ArchiveItemTemplateVersionsMutation, ArchiveItemTemplateVersionsMutationVariables>(ArchiveItemTemplateVersionsDocument, options);
      }
export type ArchiveItemTemplateVersionsMutationHookResult = ReturnType<typeof useArchiveItemTemplateVersionsMutation>;
export type ArchiveItemTemplateVersionsMutationResult = Apollo.MutationResult<ArchiveItemTemplateVersionsMutation>;
export type ArchiveItemTemplateVersionsMutationOptions = Apollo.BaseMutationOptions<ArchiveItemTemplateVersionsMutation, ArchiveItemTemplateVersionsMutationVariables>;